export const fieldTypes = [
  "text",
  "textarea",
  "email",
  "phone",
  "number",
  "date",
  "select",
  "radio",
  "checkbox",
  "termsAgreement",
  "multiSelect",
  "file",
  "country",
] as const;
export const fileTypes = [
  "application/pdf",
  "image/png",
  "image/jpeg",
] as const;
export type FieldType = (typeof fieldTypes)[number];
export type Answer = string | number | boolean | string[];
export type Row = Record<string, Answer>;
export type Answers = Record<string, Answer | Row[]>;
export type Field = {
  id: string;
  type: FieldType;
  label: string;
  description?: string;
  termsUrl?: string;
  termsLinkText?: string;
  placeholder?: string;
  required?: boolean;
  min?: number;
  max?: number;
  options?: { id: string; label: string }[];
  equalTo?: string;
  when?: { fieldId: string; value: string; aliases?: string[] };
  mimeTypes?: (typeof fileTypes)[number][];
  maxBytes?: number;
  core?: "firstName" | "lastName" | "email";
};
export type Section = {
  id: string;
  label: string;
  repeat?: { min: number; max: number };
  fields: Field[];
};
export type FormSchema = {
  version: 1;
  title: string;
  sections: Section[];
  programmes: { label: string; offeringId: number; intakes: string[] }[];
  uploadGroups: {
    id: string;
    label: string;
    fieldIds: string[];
    required: boolean;
  }[];
};
export type FormContext = {
  required: boolean;
  revision: { id: number; schema: FormSchema } | null;
};
export type FormSnapshot = {
  revisionId: number;
  offeringId: number;
  schema: FormSchema;
  intake: string;
  answers: Answers;
  uploads: Upload[];
};
export type FormResponse = FormSnapshot & {
  draftKey: string | null;
  history: (FormSnapshot & { id: number; submittedAt: string })[];
};
export type Upload = { id: string; filename: string };
export const formError = (error: unknown) => {
  if (error instanceof Error) {
    const response = (
      error as Error & { response?: { data?: { error?: string } } }
    ).response;
    return response?.data?.error || error.message;
  }
  return "The request could not be completed";
};
